import appEnums from 'enums/app';
import appEvents from 'events/app';
import { getChatClientConnectionStatus } from 'app/modules';

export default (async function reconnectChatClient(dispatch, getState, { chatGateway }) {
  let chatClientConnectionState = getChatClientConnectionStatus(getState());
  if (chatClientConnectionState === appEnums.chatClientConnectionStatuses.CONNECTED) {
    return;
  }
  dispatch(appEvents.chatClientReconnect());
  await chatGateway.reconnect();
});
